export const LIST = "SMS_OTP_LIST";